import { FatalError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export class FatalEvaluateError extends FatalError {
  static override locales: Locales = {
    'en-US': 'Evaluate error %s',
    'zh-CN': '计算建模错误 %s',
    'zh-HK': '計算建模錯誤 %s'
  }

  override name = 'FatalEvaluateError' as const

  constructor(public readonly originError: Error) {
    super(originError.message)
  }
}
